/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const containerMargin = css({
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
});

export const headlineCol = css({
  marginBottom: 24,
  [MediaQueries.md]: {
    marginBottom: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 16,
  },
});

export const headline = css(typography.effra48, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  position: 'relative',
  display: 'inline',
});

export const bodyText = css(typography.effra18, {
  color: colorsPalette.grey80,
  marginTop: 24,
  marginBottom: 30,
  [MediaQueries.md]: {
    marginBottom: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 24,
    marginBottom: 52,
  },
});

export const statsContainer = css({
  [MediaQueries.lgAndUp]: {
    justifyContent: 'space-between',
  },
});

export const statItem = css({
  marginBottom: 25,
  [MediaQueries.md]: {
    marginBottom: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 35,
  },
});

export const statValue = css(typography.effra48, {
  color: colorsPalette.grey60,
  fontWeight: fontWeights.light,
  [MediaQueries.mdAndUp]: {
    paddingTop: 10,
  },
  [MediaQueries.lgAndUp]: {
    borderTop: `1px solid ${colorsPalette.grey20}`,
    paddingTop: 25,
  },
});

const statLabelFont = css({
  fontSize: 16,
  lineHeight: 1.5,
  fontWeight: fontWeights.regular,
  paddingLeft: 4,
  [MediaQueries.lgAndUp]: {
    fontSize: 18,
    lineHeight: 1.67,
  },
});

export const statLabel = css(statLabelFont, {
  color: colorsPalette.grey60,
});

export const softCTA = css(typography.effra16, {});

export const hardCTA = css({
  marginTop: 15,
});
